// extracted by mini-css-extract-plugin
export default {"LoadError":"bes_a bhc_pw bhc_a bhc_w bhc_j bhc_q","LoadError__icon":"bes_b bhc_uf bhc_fg bhc_rq","LoadError__message":"bes_c bhc_fg bhc_sl"};